import React from 'react';
import { saveAs } from 'file-saver';

const ExportCSV = ({data, fileName}) => {


  const handleDownload = () => {
    // 1. Define CSV headers and format data
    const headers = ['Date', 'Bond', 'Cash', 'Equity', 'Money Markets'];
    const csvRows = data.map(row => 
      headers.map(header => JSON.stringify(row[header.toLowerCase()])).join(',')
    );
    const csvContent = [headers.join(','), ...csvRows].join('\n');

    // 2. Create a Blob and trigger the download using FileSaver
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${fileName}.csv`);
  };

  return (
    <button className="nav-link funds-btn dark-p-history"  onClick={handleDownload} >
       CSV
    </button>
  );
};

export default ExportCSV;